module.exports = __webpack_public_path__ + "img/RORBPJR12019.d4d613f1.png";